import { NotificationCounters } from '../../model/notifications/notification-counter.model';
import { NotificationCountersApi } from '@core/api/model/notifications/notification-counters-api.model';
import { HeaderNotification, NotificationCategories } from '../../model/notifications/notification.model';

export class NotificationCountersMapper {
  static fromApiToModel(c: NotificationCountersApi): NotificationCounters {
    return {
      unread: c.noLeidas,
      [NotificationCategories.ALL]: c.todas,
      [NotificationCategories.URGENT]: c.urgentes,
      [NotificationCategories.ARCHIVED]: c.archivadas,
      [NotificationCategories.ALERT]: c.alertas,
      [HeaderNotification.INVOICES]: c.facturas,
      [HeaderNotification.PROCEDURES]: c.tramites,
    };
  }
}
